module.exports = __webpack_public_path__ + "static/media/audio-01-ru.d10e58b5.mp3";